const VIDEO_EXTENSIONS = ["mp4", "webm", "ogg", "mov", "m4v", "mkv"];

export const isDirectVideo = (url) => {
  const value = String(url || "").trim();
  if (!value) return false;
  return new RegExp(`\\.(${VIDEO_EXTENSIONS.join("|")})(?:[?#].*)?$`, "i").test(value);
};

export const driveId = (source) => {
  const value = String(source || "").trim();
  if (!value) return "";

  const directMatches = [
    value.match(/[?&]id=([^&#]+)/)?.[1],
    value.match(/[?&]export=download.*[?&]id=([^&#]+)/)?.[1],
    value.match(/\/d\/([^/?]+)/)?.[1],
    value.match(/\/file\/d\/([^/?]+)/)?.[1],
  ];

  const id = directMatches.find(Boolean);
  if (id) return id;

  try {
    const url = new URL(value);
    if (url.hostname !== "drive.google.com") return "";
    return url.searchParams.get("id") || url.pathname.match(/\/d\/([^/?]+)/)?.[1] || "";
  } catch {
    return "";
  }
};

export const parseVideoLink = (source) => {
  const value = String(source || "").trim();
  if (!value) return { videoUrl: "", coverUrl: "", isFile: false, invalidLink: false };

  if (isDirectVideo(value)) {
    return { videoUrl: value, coverUrl: "", isFile: true, invalidLink: false };
  }

  const id = driveId(value);
  if (!id) return { videoUrl: "", coverUrl: "", isFile: false, invalidLink: true };

  return {
    videoUrl: `https://drive.google.com/file/d/${id}/preview?autoplay=1`,
    coverUrl: `https://drive.google.com/thumbnail?id=${id}&sz=w600`,
    isFile: false,
    invalidLink: false,
  };
};
